import { ApiMultiAuditLogEntryResponse, V2PostAuditLogSearchesBody } from 'types/swagger/clarifai-api';
import { fetchApi } from 'utils/request';

export const fetchAuditLogSearches = ({
  userId,
  body = {},
}: {
  userId: string;
  body: V2PostAuditLogSearchesBody;
}): Promise<ApiMultiAuditLogEntryResponse> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/audit_log/searches`,
    method: 'POST',
    body,
  });
